import { useEffect, useRef, useState } from 'react';

import MarkerSVG from '@/assets/images/marker.svg';

import type { FunctionComponent } from 'react';
import type { TypeMarkerProps } from './types';

/**
 * Marker
 */
export const Marker: FunctionComponent<TypeMarkerProps> = ({
  className = '',
  children,
  onClick,
}: TypeMarkerProps) => {
  const [show, setShow] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = ref.current;

    if (show && element) {
      const parent = element.parentElement;
      parent?.style.setProperty('z-index', '10');
    }

    return () => {
      if (element) {
        const parent = element.parentElement;
        parent?.style.setProperty('z-index', '0');
      }
    };
  });

  return (
    <>
      <div
        ref={ref}
        className={`inline-block -translate-x-1/2 -translate-y-1/2 ${className}`}
      >
        <MarkerSVG
          className={`h-8 w-8 ${children ? 'cursor-pointer' : ''}`}
          {...(children && {
            onClick: () => {
              setShow((show) => !show);
              onClick?.();
            },
          })}
        />
      </div>

      {show
        ? typeof children === 'function'
          ? children({ isOpen: show, close: () => setShow(false) })
          : children
        : null}
    </>
  );
};

Marker.displayName = 'Marker';
